import cookies from 'utils/cookies';
import { createActions } from 'redux-actions'
import { isInteger } from 'lodash'


const Cart = createActions({
  CART_COUNT() {
    const cart_count = parseInt(cookies.get('cart_count'), 10);

    return {
      count: isInteger(cart_count) ? cart_count : 0
    }
  }
})

export default Cart
